import Vue from 'vue'

const state = {
  baseUri: '/botw/config/contract/'
}
const getters = {
}
const actions = {
  codes: function (_context, callback) { // 공통 코드 조회
    const axiosOption = {
      method: 'GET',
      url: _context.state.baseUri + 'codes'
    }
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  search: function (_context, [searchParam, tempPageNum, rowCount, callback]) { // 내역 조회
    const params = {}
    if (tempPageNum !== null && rowCount !== null) {
      params.pageNum = tempPageNum
      params.rowCount = rowCount
    }
    for (const key in searchParam) {
      if (Object.hasOwnProperty.call(searchParam, key)) {
        params[key] = searchParam[key]
      }
    }
    console.log('actions search : ', params)
    const axiosOption = {
      method: 'GET',
      url: _context.state.baseUri + 'search',
      params: params
    }
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  insert: function (_context, [data, callback]) { // 등록
    data = JSON.parse(JSON.stringify(data))
    console.log('insert data: ', data)
    const axiosOption = {
      method: 'POST',
      url: _context.state.baseUri + 'insert',
      data: data
    }
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  update: function (_context, [data, callback]) { // 수정
    data = JSON.parse(JSON.stringify(data))
    console.log('update data: ', data)
    const axiosOption = {
      method: 'POST',
      url: _context.state.baseUri + 'update',
      data: data
    }
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  detail: function (_context, [contractSeq, callback]) { // 상세 조회
    console.log('detail : ', contractSeq)
    const axiosOption = {
      method: 'GET',
      url: _context.state.baseUri + 'detail/' + contractSeq
    }
    Vue.axios(axiosOption).then(callback)
  },
  spotSearch: function (_context, [spotSearchParam, callback]) { // 현장 조회
    console.log('spotSearch data: ', spotSearchParam)
    const axiosOption = {
      method: 'GET',
      url: _context.state.baseUri + 'spotSearch',
      params: spotSearchParam
    }
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  remove: function (_context, [data, callback]) { // 삭제
    console.log('remove data: ', data)
    const axiosOption = {
      method: 'POST',
      url: _context.state.baseUri + 'delete',
      data: data
    }
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  fileCodeUpdate: function (_context, [data, callback]) {
    console.log('fileCodeUpdate : ', data)
    const axiosOption = {
      method: 'POST',
      url: _context.state.baseUri + 'fileCodeUpdate',
      data: data
    }
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  fileCodeInit: function (_context, [data, callback]) {
    console.log('fileCodeInit : ', data)
    const axiosOption = {
      method: 'POST',
      url: _context.state.baseUri + 'fileCodeInit',
      data: data
    }
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  spotContractList: function (_context, [data, callback]) { // 상세 조회
    console.log('spotContractList : ', data)
    const axiosOption = {
      method: 'GET',
      url: _context.state.baseUri + 'spotContractList',
      params: data
    }
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  }
}
const mutations = {
}
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
